import React from 'react';
import LivestreamCompactBanner from './components/LivestreamCompactBanner';

function App() {
  return (
    <div className="min-h-screen bg-[#060c1a]">
      {/* The ONE component we actually want */}
      <LivestreamCompactBanner />
    </div>
  );
}

export default App;